(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["miniracers-feature"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('miniracers-feature')) {
  customElements.define('miniracers-feature', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const radios = [...this.querySelectorAll('input[type=radio]')];
      const split = this.querySelector('[data-split]');
      const update = (radio) => {
        split.hidden = true;
        radios.forEach(input => { input.checked = input === radio; });
        this.querySelectorAll('[data-gallery]').forEach(gallery => { gallery.hidden = gallery.dataset.gallery !== radio.value; });
        this.querySelector('[data-price]').textContent = radio.dataset.price;
        this.querySelector('[data-sticky-price]').textContent = radio.dataset.price;
        const compare = this.querySelector('[data-compare]');
        compare.textContent = radio.dataset.compare;
        compare.hidden = radio.dataset.sale !== 'true';
        const saving = this.querySelector('[data-saving]');
        saving.textContent = 'Economisești ' + radio.dataset.saving;
        saving.hidden = compare.hidden;
        this.querySelector('[data-offer-note]').hidden = compare.hidden;
        this.querySelectorAll('[data-action-label]').forEach(label => { label.textContent = 'Precomandă'; });
        this.querySelector('[data-design-title]').textContent = radio.dataset.title;
        this.querySelector('[data-design-copy]').textContent = radio.dataset.title === 'Street Art' ? 'Grafică multicoloră, numărul 808 și accente portocalii.' : 'Albastru cobalt în spate. Indigo în față. Grile argintii.';
        const target = new URL(this.dataset.productUrl, location.origin);
        target.searchParams.set('variant', radio.value);
        const incoming = new URLSearchParams(location.search);
        ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'ttclid'].forEach(key => {
          if (incoming.has(key)) target.searchParams.set(key, incoming.get(key));
        });
        this.querySelectorAll('[data-product-link]').forEach(link => { link.href = target.pathname + target.search; });
      };
      this.addEventListener('change', event => {
        if (radios.includes(event.target)) update(event.target);
      });
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-photo]');
        if (!button) return;
        const gallery = button.closest('[data-gallery]');
        const image = gallery.querySelector('.mr-feature__main');
        image.removeAttribute('srcset');
        image.src = button.dataset.photo;
        image.alt = button.dataset.alt;
        gallery.querySelectorAll('[data-photo]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      });
      split.hidden = false;
      this.querySelectorAll('[data-gallery]').forEach(gallery => { gallery.hidden = true; });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
